<template>
    <div class="row" id="install-code">
      <div>
        <h4 class="font-weight-bold">Installation Guide</h4>
        <p class="margin-align" >Follow the instruction below.</p>
      </div>

      <!--Layout-1: wordpress & opencart-->
      <div v-if="isLayout[1]">
        <div class="row mt-1 mb-4 mx-auto">
          <p>1</p>
          <div class="ml-3">
            <p class="my-0">Add {{ $isMida ? 'Mida' : 'Howuku' }} plugin to your site.</p>
            <button @click="openLink(plugin.toURL)" class="btn btn-first mt-3 mb-2">Get plugin</button>
          </div>
        </div>
        <div class="row mt-4 mb-3 mx-auto">
          <p>2</p>
          <div class="ml-3">
            <p>Copy the code below, paste into your {{ $isMida ? 'Mida' : 'Howuku' }} plugin, and save it.</p>
          </div>
          <div>
            <div class="clipboard mx-auto text-right">
            <span
              class="cursor-pointer btn mt-1 p-0"
              id="btn-copy"
              style="position: absolute; padding: 8px; font-size: 0.8rem; border-radius: 3px !important; padding-left: 4px !important; padding-right: 4px !important; background-color: #ffffff; right: 1rem;"
              @click="copyToClipboard"
            >
              <font-awesome-icon icon="paste" class="fa-sm" style="font-size: 0.8rem;" />
              Copy
            </span>
            </div>
            <pre
              id="code-snippet"
              class="font-weight-bold baby-blue"
              v-if="$isHowuku && 1 === 2"
            >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre
            >
            <pre id="code-snippet" class="font-weight-bold code-adjustment baby-blue" v-else-if="$isOptimize || $isMida">
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script type="text/javascript" async src="https://{{$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'}}/js/optimize.js?key={{this.secretCode}}">&lt;/script></pre>
            <pre id="code-snippet" class="font-weight-bold code-adjustment baby-blue" v-else>
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL() }}/js/{{ this.$isOptimize || this.$isMida ? 'optimize' : 'track' }}.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre>
          </div>
        </div>
        <div class="row mt-2 mb-3 mx-auto">
          <div>3</div>
          <div class="ml-3">
            <p class="pb-0 mb-2">Verify if {{ $isMida ? 'Mida' : 'Howuku' }} is receiving data from your site.</p>
            <input
              type="text"
              v-model="websiteURL"
              class="web-icon form-control verify-input"
            />
            <button @click="verifyWebsite()" class="btn btn-third my-3 verify-button">Verify Installation</button>
            <span v-if="!isValidURL" class="px-3 warning">Invalid website URL</span>
          </div>
        </div>
      </div>
      <!--Layout-2: shopify-->
      <div v-if="isLayout[2]">
      <!-- will be used once the plugin is ready -->
       <div class="row mt-1 mb-3 mx-auto">
          <p>1</p>
          <div class="ml-3">
            <p class="my-0">If you haven't install {{ $isMida ? 'Mida' : 'Howuku' }} App on your Shopify store, please follow this link to install it.</p>
          </div>
          <div class="ml-4 full">
            <a target="_blank" href="https://apps.shopify.com/howuku"><button class="btn btn-first mb-3">Go to Shopify App</button></a>
          </div>
          <div class="ml-4 mt-3 mb-3">
          </div>
        </div>        
        <div class="row mt-1 mb-3 mx-auto">
          <p>2</p>
          <div class="ml-3">
            <p class="my-0">Enter your Shopify store URL to connect <span v-if="$isHowuku">it to Howuku</span></p>
          </div>
          <div class="ml-4 w-100">
            <input
              class="form-control d-inline w-50"
              placeholder="Shopify store URL"
              type="text"
              v-model="shopifyURL"
            />
            <button v-if="!isSaved" @click="saveDomain"  class="d-inline btn btn-third mb-1">Save store URL</button>
            <span v-else class="text-success ml-2">Saved!</span>
            <br>
            <p class="my-0 text-muted">Once you have completed the above steps {{ $isMida ? 'Mida' : 'Howuku' }} will automatically start receiving data from your Shopify store.</p>
          </div>
        </div>
      
      </div>
      <!--Layout-3: other platform-->
      <div v-if="isLayout[3]">
        <div class="row mt-1 mx-auto">
          <p>1</p>
          <div class="ml-3">
            <p>Copy the tracking code below.</p>
          </div>
          <div>
            <div class="clipboard mx-auto text-right">
            <span
              class="cursor-pointer btn mt-1 p-0"
              id="btn-copy"
              style="position: absolute; padding: 8px; font-size: 0.8rem; border-radius: 3px !important; padding-left: 4px !important; padding-right: 4px !important; background-color: #ffffff; right: 1rem;"
              @click="copyToClipboard"
            >
              <font-awesome-icon icon="paste" class="fa-sm" style="font-size: 0.8rem;" />
              Copy
            </span>
            </div>
            <pre id="code-snippet"
              class="baby-blue"
              v-if="$isMida"
            >{{ fullCode }}</pre>            
            <pre id="code-snippet"
              class="font-weight-bold baby-blue"
              v-else-if="$isHowuku && 1 === 2"
            >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre>            
<pre id="code-snippet" class="font-weight-bold baby-blue" v-else>
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL() }}/js/{{ this.$isOptimize || this.$isMida ? 'optimize' : 'track' }}.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre>
          </div>
        </div>
        <div v-if="$isMida" style="display: flex;" class="ml-3 mb-4">
          <div class="overview-manual-1"></div>
          <div>
            <toggle-button @change="triggerAntiflicker" v-model="antiflicker" class="my-auto" color="#2eb15a" :labels="true" /> <span class="tooltip-pop ml-2" rel="Anti-flickering refers to the prevention of sudden visual changes on a webpage or app which might occur during testing.">Include <b>anti-flickering</b> script</span><br><br>
            <toggle-button @change="triggerConsentCode" v-model="consentcode" class="my-auto" color="#2eb15a" :labels="true" /> <span class="tooltip-pop ml-2" rel="Show A/B test to visitors but only track consented users, this will require some coding efforts.">Use strict consent mode</span>

            <div v-if="consentcode" class="mt-3 pl-3 ml-3" style="border-left: 1px dashed #ccc!important">
            <p class="fs-13 text-muted"><span class="badge badge-info">IMPORTANT</span> Execute the following code when cookie consent is accepted or declined through GTM or your Consent Management Tools:</p>
            <pre id="code-snippet" class="baby-blue">// to accept consent
mida.grantConsent(true)

// to decline consent
mida.grantConsent(false)
</pre>       
<a href="https://mida.freshdesk.com/support/solutions/articles/154000146683-cookies-consent-and-mida-s-adherence" target="_blank" class="a-link text-muted">Learn how it works before implementation</a>     
            </div>          
          </div>          
        </div>          
        <div class="row mt-3 mb-3 mx-auto">
          <div>2</div>
          <div class="ml-3">
            <p class="my-0">Please check out the installation guide to make necessary change.</p>
            <button @click="openLink(plugin.toURL)" class="btn btn-third my-3">View installation guide</button>
          </div>
        </div>
        <div class="row mt-2 mb-3 mx-auto">
          <div>3</div>
          <div class="ml-3">
            <p class="pb-0 mb-2">Verify if {{ $isMida ? 'Mida' : 'Howuku' }} is receiving data from your site.</p>
            <input
              type="text"
              v-model="websiteURL"
              class="web-icon form-control verify-input"
            />
            <button @click="verifyWebsite()" class="btn btn-third my-3 verify-button">Verify Installation</button>
            <span v-if="!isValidURL" class="px-3 warning">Invalid website URL</span>
          </div>
        </div>
      </div>
      <!--Layout-4: install manual-->
      <div v-if="isLayout[4]">
        <div class="row mt-1 mb-3 mx-auto">
          <p>1</p>
          <div class="ml-3">
            <p class="margin-align">Copy and paste the tracking code below into the <span class="font-weight-bold text-primary">&lt;HEAD&gt;</span>
              tag on every page where you wish to<br/> track visitors and collect feedback.</p>
          </div>
          <div>
            <div class="clipboard mx-auto text-right">
            <span
              class="cursor-pointer btn mt-1 p-0"
              id="btn-copy"
              style="position: absolute; padding: 8px; font-size: 0.8rem; border-radius: 3px !important; padding-left: 4px !important; padding-right: 4px !important; background-color: #ffffff; right: 1rem;"
              @click="copyToClipboard"
            >
              <font-awesome-icon icon="paste" class="fa-sm" style="font-size: 0.8rem;" />
              Copy
            </span>
            </div>
            <pre
              id="code-snippet"
              class="font-weight-bold baby-blue"
              v-if="$isHowuku && 1 === 2"
            >
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(h,o,w,u,k,u){
  u=['track','identify','converted'],h.o=h.howuku||{},
  u.map(function(n){return h.o[n]=h.o[n]||function(){(h.o[n].q=h.o[n].q||[]).push(arguments);};}),h.howuku=h.o,
  k=o.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL()}}/js/{{
                $session.get('company_id') === 1334 ? 'track' : 'howu'
              }}.js",k.setAttribute("key",w),
  o.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre
            >
            <pre id="code-snippet" class="font-weight-bold baby-blue" v-else-if="$isOptimize">
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script type="text/javascript" async src="https://{{$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'}}/js/optimize.js?key={{this.secretCode}}">&lt;/script></pre>
            <pre id="code-snippet" class="font-weight-bold baby-blue" v-else>
&lt;!-- {{ $customdomain().name }} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://{{ $trackingURL() }}/js/{{ this.$isOptimize || this.$isMida ? 'optimize' : 'track' }}.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "{{ this.secretCode }}");
&lt;/script></pre>
          </div>
        </div>
        <div class="row mt-3 mb-3 mx-auto">
          <div>2</div>
          <div class="ml-3">
            <p class="pb-0 mb-2">Verify if {{ $isMida ? 'Mida' : 'Howuku' }} is receiving data from your site.</p>
            <input
              type="text"
              v-model="websiteURL"
              class="web-icon form-control verify-input"
            />
            <button @click="verifyWebsite()" class="btn btn-third my-3 verify-button">Verify Installation</button>
            <span v-if="!isValidURL" class="px-3 warning">Invalid website URL</span>
          </div>
        </div>
      </div>



      <!--Layout-5: wordpress-->
      <div v-if="isLayout[5]">
        <div class="row mt-1 mb-4 mx-auto">
          <p>1</p>
          <div class="ml-3">
            <p class="my-0">Download Wordpress Plugin and install it on your WP Site.</p>
            <button @click="openLink('https://cdn.mida.so/mida.zip')" class="btn btn-first mt-3 mb-2">Download Plugin - mida.zip</button>
          </div>
        </div>
        <img src="https://www.wpbeginner.com/wp-content/uploads/2020/02/uploadpluginbutton.png" class="img-fluid ml-4"/>

        <div class="row mt-4 mb-3 mx-auto">
          <p>2</p>
          <div class="ml-3">
            <p>Copy the Project Key to WP site and save it.</p>
            <p><b>Your Project Key:</b> <code class="ml-2">{{ secretCode }}</code></p>
          </div>
        </div>
        <div class="row mt-2 mb-3 mx-auto">
          <div>3</div>
          <div class="ml-3">
            <p class="pb-0 mb-2">Verify if Mida is receiving data from your site.</p>
            <input
              type="text"
              v-model="websiteURL"
              class="web-icon form-control verify-input"
            />
            <button @click="verifyWebsite()" class="btn btn-third my-3 verify-button">Verify Installation</button>
            <span v-if="!isValidURL" class="px-3 warning">Invalid website URL</span>
          </div>
        </div>
      </div>



    </div>
</template>

<script>
import JSConfetti from 'js-confetti'

export default {
  name: 'InstallGuide',
  props: {
    plugin: Object,
    layout: Number,
    websiteURL: String,
    secretCode: String,
    selectedWidgetId: Number
  },
  data: () => ({
    isLayout: {
      1: false,
      2: false,
      3: false,
      4: false,
      5: false
    },
    shopifyURL: '',
    isHowuku:
      window.location.href.includes('howuku.com') ||
      window.location.href.includes('localhost:'),
    fullCode: '',
    isValidURL: true,
    isSaved: false
  }),
  mounted() {
    this.isLayout[this.layout] = true
    // if not showing shopify
    if (this.isLayout[2]) {
      this.shopifyURL = this.websiteURL
    } else {
      this.setFullCode(this.secretCode)

      // this.fullCode = document.getElementById('code-snippet').innerHTML
      // this.fullCode = this.fullCode.replace(/&lt;/g, '<')
      // this.fullCode = this.fullCode.replace(/&gt;/g, '>')
      // this.fullCode = this.fullCode.replace(/ /g, '')
      // this.fullCode = this.fullCode.replace(/var/g, 'var ')
      // this.fullCode = this.fullCode.replace(
      //   /HowukuTrackingCode/g,
      //   ' Howuku Tracking Code '
      // )
    }
  },
  methods: {
    setFullCode(secretCode) {
      if (this.$isOptimize) {
        this.fullCode = ''

        if (this.antiflicker) {
          this.fullCode += `&lt;!-- Anti-flickering script -->\n`    
          this.fullCode += `&lt;script>
  var timeout = 3000; // Timeout value to remove the flicker (in milliseconds)
  !function(h,i,d,e){var t,n=h.createElement("style");n.id=e,n.innerHTML="body{opacity:0}",h.head.appendChild(n),t=d,i.rmfk=function(){var t=h.getElementById(e);t&&t.parentNode.removeChild(t)},setTimeout(i.rmfk,t)}(document,window,timeout,"abhide");
&lt;/script>\n\n`
        }    

        this.fullCode += `&lt;!-- ${this.$customdomain().name} A/B Testing Script -->\n`    
        this.fullCode += `&lt;script type="text/javascript" async src="https://${this.$isMida ? 'cdn.mida.so' : 'cdn.howuku.com'}/js/optimize.js?key=${secretCode}${this.consentcode ? '&cookie=1' : ''}">&lt;/script>`
      } else {
        this.fullCode = `&lt;!-- ${this.$customdomain().name} Tracking Code -->
&lt;script>
(function(t,r,a,c,k){
  c=['track','identify','converted'],t.o=t._init||{},
  c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
  k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://${this.$getCustomCDN()}/js/${ this.$isOptimize || this.$isMida ? 'optimize' : 'track' }.js",k.setAttribute("key",a),
  r.getElementsByTagName("head")[0].appendChild(k);
})(window, document, "${secretCode}");
&lt;/script>`
      }
    this.fullCode = this.fullCode.replace(/&lt;/g, '<')
    this.fullCode = this.fullCode.replace(/&gt;/g, '>')
    // this.fullCode = this.fullCode.replace(/ /g, '')
    this.fullCode = this.fullCode.replace(/var/g, 'var ')
    this.fullCode = this.fullCode.replace(/HowukuTrackingCode/g,' Howuku Tracking Code ')      
    },
    triggerAntiflicker() {
      this.setFullCode(this.secretCode)
    },
    triggerConsentCode() {
      this.setFullCode(this.secretCode)
    },
    saveDomain() {
      this.$http
        .post(process.env.API_ENDPOINT + '/saveWidget', {
          widget_id: this.selectedWidgetId || this.$session.get('widget_id'),
          widget_allowed_website: this.shopifyURL.replace(/^http(s)?\:\/\/(www.)?/, '').split('/')[0]
        })
        .then((response) => {
          console.log('saved ' + this.shopifyURL.replace(/^http(s)?\:\/\/(www.)?/, '').split('/')[0])
          this.isSaved = true
          
          setTimeout(() => {
            this.isSaved = false
          }, 5000)
        })
    },
    copyToClipboard() {
      // 1) Add the text to the DOM (usually achieved with a hidden input field)
      const input = document.createElement('textarea')
      document.getElementById('install-code').appendChild(input)
      input.value = this.fullCode

      // 2) Select the text
      input.focus()
      input.select()

      // 3) Copy text to clipboard
      const isSuccessful = document.execCommand('copy')
      input.parentElement.removeChild(input)

      // 4) Catch errors
      if (!isSuccessful) {
        console.error('Failed to copy text.')
      } else {
        this.$awn.success('Copied to clipboard!', {
          position: 'bottom-right',
          maxNotifications: 1,
        })   
      }
    },
    openLink(url) {
      let installationWindow = window.open(url, '_blank')
      let interval = setInterval(() => {
        if (installationWindow.closed) {
          clearInterval(interval)
        }
      }, 100)
    },
    isURL(str) {
      let whiteSpacePattern = new RegExp('\\s', 'g')
      var pattern = new RegExp(
        '[(http(s)?):\\/\\/(www\\.)?a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,9}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)|localhost',
        'ig'
      )
      return pattern.test(str) && !whiteSpacePattern.test(str)
    },
    validURL(s, protocols) {
      try {
        let url = new URL(s)
        return protocols
          ? url.protocol
            ? protocols.map(x => `${x.toLowerCase()}:`).includes(url.protocol)
            : false
          : true
      } catch (err) {
        return false
      }
    },
    checkProtocol(s) {
      // search for http or https with whitespace between
      let httpsPattern = /^\s*h\s*t\s*t\s*p\s*s\s*:\s*\/\s*\/\s*/ig
      let httpPattern = /^\s*h\s*t\s*t\s*p\s*\s*:\s*\/\s*\/\s*/ig

      if (httpPattern.test(s)) {
        return s.replace(httpPattern, 'http://')
      } else if (httpsPattern.test(s)) {
        return s.replace(httpsPattern, 'https://')
      }
      return s
    },
    verifyWebsite() {
      // alert(123)
      console.log(this.$parent.name)
      // remove params
      this.websiteURL = this.checkProtocol(this.websiteURL.trim())
      let tempURL = this.websiteURL
      tempURL = tempURL.split('?')[0]
      // auto-assign protocol if not exist
      if (!this.validURL(tempURL, ['http', 'https'])) tempURL = 'https://' + tempURL
      if (this.isURL(tempURL)) {
        this.isValidURL = true
        this.websiteURL = tempURL
        this.$http
          .post(process.env.API_ENDPOINT + '/saveWidget', {
            widget_id: this.selectedWidgetId || this.$session.get('widget_id'),
            widget_allowed_website: this.websiteURL
          })
          .then((response) => {
            let installationStatus = 0
            if (!this.websiteURL.startsWith('http')) {
              this.websiteURL = 'https://' + this.websiteURL
            }
            let newWindow = open(
              this.websiteURL + '?verify=' + this.secretCode,
              'example',
              'width=500,height=500'
            )

            let counter = 0;
            let interval = setInterval(() => {
              // If status = 0 and after 5 seconds
              if (counter > 80 && installationStatus === 0) {
                installationStatus = 2
                clearInterval(interval)
                // close window
                newWindow.close()             
              }

              if ((newWindow.closed || counter >= 80) && installationStatus === 0) {
                installationStatus = 1
                clearInterval(interval)

                try {
                  newWindow.close()             
                } catch(x){}
                
                this.$http.get(process.env.API_ENDPOINT + '/installation/status/' + this.selectedWidgetId)
                .then((response) => {
                  if (response.status === 200) {
                    this.$modal.hide(this.$parent.name)
                    console.log(this.$parent.name)
                    // throw confetti
                    this.$router.push({ path: '/' })

                    setTimeout(() => {
                      const jsConfetti = new JSConfetti()
                      if (this.$isHowuku || this.$isMida) {
                        jsConfetti.addConfetti()
                        this.$swal.fire({
                          title: this.t('Installation successful!'),
                          text: this.t(`${this.$isMida ? 'Mida' : 'Howuku'} is capturing data on your site, and you’re ready to get started with all of ${this.$isMida ? 'Mida' : 'Howuku'}’s tools.`),
                          type: 'success',
                          confirmButtonColor: '#2167f5'
                        })

                        if (this.$isMida) this.$setInsight("Install Mida pixel", 1)
                        jsConfetti.addConfetti({
                          emojis: ['🌈', '⚡️', '💥', '✨', '💫', '🌸'],
                        })
                        try {
                          this.$auditlog({ module: 'installation', action: 'tracking_code_installed' })  
                          this.$track('tracking_code_installed')
                        } catch(e) {}
                        this.submitAnswer("Setup tracking code",1)
                        window.CREATE_EXPERIMENT = 1
                      }
                    }, 1000);
                  } else {
                    this.$swal.fire({
                      title: this.t('Cannot find tracking script'),
                      text: this.t(`We are unable to detect ${this.$isMida ? 'Mida' : 'Howuku'} tracking script on the provided website. You may wanted to recheck on your installation setup or if you have the correct website URL for verification.`),
                      type: 'error',
                      confirmButtonColor: '#2167f5'
                    })                       
                  }
                })
              }
              counter++;
            }, 100)
          })
      } else this.isValidURL = false
    },
    submitAnswer(q, answer) {
      this.$http
        .post(process.env.API_ENDPOINT + '/user/attribute', {
          key: q,
          value: answer,
        })
        .catch((err) => {
          console.error(err)
        })
    },
  },
}
</script>

<style scoped>

.warning {
  color: red;
}

pre.baby-blue {
  /*word-wrap: break-word;*/
  max-width: 735px;
  white-space: pre-wrap;
  background-color: rgba(var(--main-color),1);
  color: white;
  padding: 15px;
  font-size: 11px;
  word-wrap: break-word;
  overflow: hidden;
}

.text-center {
  text-align:center;
}

.full {
  width: 50%;
}

.text-right {
  text-align:end;
}

p {
  font-size: 110%;
}

.row {
  /* min-width: 100%; */
  display: flex;
}

.clipboard {
  min-width: 100%;
  display: flex;
  justify-content: end;
}

.text-first {
  color: rgba(var(--main-color),1);
  padding-bottom: 0px;
  margin-bottom: 10px;
}

.margin-align {
  margin-bottom: 0.5rem;
}

.verify-input {
  display: inline-block;
}

.verify-button {
  padding-top: 10.5px;
  padding-bottom: 10.5px;
  margin-bottom: 20px !important;
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/InstallGuide.vue